import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Navbar, Nav, NavDropdown, Button, Modal, Form, Image } from 'react-bootstrap';
import { connect } from 'react-redux';

import { IconContext } from "react-icons";
import { FaHome, FaWhatsappSquare } from 'react-icons/fa';
import { VscBook, VscAccount, VscCallOutgoing } from 'react-icons/vsc';
import { GiSuspensionBridge, GiPencilRuler, GiCargoCrane, GiCargoCrate, GiAutoRepair, GiTruck, GiMoneyStack, GiPaperClip, GiCarKey, GiSteeringWheel, GiTankTread } from 'react-icons/gi';
import { GrArticle, GrContactInfo, GrGallery } from 'react-icons/gr';
import { BsBuilding, BsInfoCircle, BsQuestionCircle } from 'react-icons/bs';
import { BiSupport, BiMailSend, BiMap, BiCheckShield, BiMessageEdit, BiBriefcase } from 'react-icons/bi';
import { CgNametag } from 'react-icons/cg';

import Logo from './Logo';

import { fetchCarCats, fetchAllCars } from '../actions/carsActions';
import { fetchTehCats } from '../actions/tehActions';
import { showModalForm, hideModalForm } from '../actions/coreActions';
import { logout } from '../actions/authActions';

import LoginForm from './auth/LoginForm';
import RegisterForm from './auth/RegisterForm';

class Navigation extends Component {
    componentDidMount() {
        this.props.fetchCarCats()
        this.props.fetchAllCars()
        this.props.fetchTehCats()
        if (this.props.logged_in) {
            this.props.fetchAuthorization()
        }
    };

    handleModalSwitch (modal1, modal2) {
        this.props.hideModalForm(modal1);
        this.props.showModalForm(modal2);
    };

    render(props) {
        const { user, isAuthenticated } = this.props.auth;

        const carcats = this.props.cars.map(carcat => (
            <Col xs={6} md={4} key={carcat.id} size="sm" className="nav-category px-0" vertical>
                <NavDropdown.Item className="py-0" href={`/product/car/${carcat.id}`}>
                    <Image src={`https://sinomost.kz${carcat.thumbnail}`} />
                    <p><small>{carcat.title}</small></p>
                </NavDropdown.Item>
            </Col>
        ));

        const tehcats = this.props.tehcats.map(tehcat => (
            <>{tehcat.items>0 &&
                <Col xs={6} md={4} key={tehcat.id} size="sm" className="nav-category" vertical>
                    <NavDropdown.Item className="dropdown-item py-0" href={`/catalog/teh/${tehcat.id}`}>
                        <Image src={`https://sinomost.kz${tehcat.image}`} />
                        <p><small>{tehcat.title}</small></p>
                    </NavDropdown.Item>
                </Col>
            }</>
        ));

        const login_form = (
            <Modal show={this.props.showLoginForm} onHide={() => this.props.hideModalForm('showLoginForm')}>
                <Modal.Header closeButton>
                    <Modal.Title>Вход</Modal.Title>
                </Modal.Header>
                <LoginForm
                    enableReinitialize={true}
                    destroyOnUnmount={true}
                    onSubmit={this.onSubmit}
                    initialValues={this.props.request}
                    history={this.props.history}
                />
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hideModalForm('showLoginForm')}>
                        Закрыть
                    </Button>
                    <Button variant="secondary" onClick={() => this.handleModalSwitch('showLoginForm','showRegisterForm')}>
                        Зарегистрироваться
                    </Button>
                    <Button type="submit" variant="warning" onClick={() => this.props.hideModalForm('showLoginForm')}>
                        Войти
                    </Button>
                </Modal.Footer>
            </Modal>
        );

        const registration_form = (
            <Modal show={this.props.showRegisterForm} onHide={() => this.props.hideModalForm('showRegisterForm')}>
                <Modal.Header closeButton>
                    <Modal.Title>Регистрация</Modal.Title>
                </Modal.Header>
                <RegisterForm
                    enableReinitialize={true}
                    destroyOnUnmount={true}
                    onSubmit={this.onSubmit}
                    initialValues={this.props.request}
                    history={this.props.history}
                />
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hideModalForm('showRegisterForm')}>
                        Закрыть
                    </Button>
                    <Button variant="warning" onClick={() => this.handleModalSwitch('showRegisterForm','showLoginForm')}>
                        Войти
                    </Button>
                    <Button variant="warning" onClick={() => this.props.hideModalForm('showRegisterForm')}>
                        Зарегистрироваться
                    </Button>
                </Modal.Footer>
            </Modal>
        );

        const logged_out_nav = (
            <NavDropdown variant="warning" alignRight="true" title={<VscAccount />} id="collasible-nav-dropdown">
                <NavDropdown.Item variant="warning" onClick={() => this.props.showModalForm('showLoginForm')}>
                    <GiCarKey /> Вход
                </NavDropdown.Item>
                <NavDropdown.Item variant="warning" onClick={() => this.props.showModalForm('showRegisterForm')}>
                    <GrContactInfo /> Регистрация
                </NavDropdown.Item>
            </NavDropdown>
        );
        const logged_in_nav = (
            <NavDropdown variant="warning" alignRight="true" title={<VscAccount />} id="collasible-nav-dropdown">
                <NavDropdown.Item href="/account">{user && user.username}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => this.props.logout()}>Выйти</NavDropdown.Item>
                <NavDropdown.Item href="/contact"><GiCargoCrate /> Моя техника</NavDropdown.Item>
            </NavDropdown>
        );


        const handleNavMsgAction = (msg) => {
            fetch('https://sinomost.kz/tgmsg/', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    tgmsg: msg,
                })
            });
        }

        return (
            <Navbar collapseOnSelect fixed="top" expand="lg" variant="custom">
                <Navbar.Brand href="/#home"><Logo /></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Link href="/" className="d-none d-md-block"><FaHome /></Nav.Link>
                        <NavDropdown title={<IconContext.Provider value={{ title: "", className: "global-class-name" }}><BsBuilding />&nbsp;Компания</IconContext.Provider>} id="collasible-nav-dropdown">
                            <NavDropdown.Item href="/about"><GiSuspensionBridge/>&nbsp;О&nbsp;Sinomost</NavDropdown.Item>
                            <NavDropdown.Item href="/documents/delivery"><GiTruck />&nbsp;Доставка</NavDropdown.Item>
                            {/*<NavDropdown.Item href="/about"><GiMoneyStack />&nbsp;Способы&nbsp;оплаты</NavDropdown.Item>
                  <NavDropdown.Item href="/guarantee"><BiCheckShield />&nbsp;Гарантия</NavDropdown.Item>*/}
                            <NavDropdown.Item href="/documents"><GiPaperClip />&nbsp;Документы</NavDropdown.Item>
                            {/*<NavDropdown.Divider />
                  <NavDropdown.Item href="/blog"><BsQuestionCircle />&nbsp;Вопросы&nbsp;и&nbsp;ответы</NavDropdown.Item>
                  <NavDropdown.Item href="/blog"><BiMessageEdit />&nbsp;Отзывы</NavDropdown.Item>
                  <NavDropdown.Item href="/blog"><GrArticle />&nbsp;Полезные&nbsp;статьи</NavDropdown.Item>
                  <NavDropdown.Item href="/blog"><GrGallery />&nbsp;Галерея</NavDropdown.Item>
                  <NavDropdown.Item href="/marketing"><GiPencilRuler />&nbsp;Партнерам</NavDropdown.Item>
                  <NavDropdown.Item href="/vacancy"><BiBriefcase />&nbsp;Вакансии</NavDropdown.Item>*/}
                        </NavDropdown>
                        <NavDropdown className="dropdown-mega" title={<IconContext.Provider value={{ title: "", className: "global-class-name" }}><GiSteeringWheel />&nbsp;Легковые&nbsp;Авто</IconContext.Provider>} id="collasible-nav-dropdown">
                            <Row className="w-100 m-0">
                                {carcats}
                                <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                                    <NavDropdown.Item className="py-0" href={`/catalog/car`}>
                                        <span className="ml-3"><VscBook />&nbsp;Смотреть&nbsp;все</span>
                                    </NavDropdown.Item>
                                </Col>
                                <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                                    <NavDropdown.Item className="py-0" href={`/catalog/carbrands`}>
                                        <span className="ml-3"><CgNametag />&nbsp;Бренды</span>
                                    </NavDropdown.Item>
                                </Col>
                            </Row>
                        </NavDropdown>
                        <NavDropdown className="dropdown-mega" title={<IconContext.Provider value={{ title: "", className: "global-class-name" }}><GiTankTread />&nbsp;Спецтехника</IconContext.Provider>} id="collasible-nav-dropdown">
                            <Row>
                                {tehcats}
                                <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                                    <NavDropdown.Item className="py-0" href={`/catalog/teh`}>
                                        <span className="ml-3"><VscBook />&nbsp;Смотреть&nbsp;все</span>
                                    </NavDropdown.Item>
                                </Col>
                                <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                                    <NavDropdown.Item className="py-0" href={`/catalog/tehbrands`}>
                                        <span className="ml-3"><CgNametag />&nbsp;Бренды</span>
                                    </NavDropdown.Item>
                                </Col>
                            </Row>
                        </NavDropdown>
                        {/*<NavDropdown className="dropdown-mega" title={<IconContext.Provider value={{ title: "", className: "global-class-name" }}><GiCargoCrane />&nbsp;Запчасти</IconContext.Provider>} id="collasible-nav-dropdown">
                  <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                    <NavDropdown.Item className="py-0" href={`/catalog/detail`}>
                      <span className="ml-3"><VscBook />&nbsp;Смотреть&nbsp;все</span>
                    </NavDropdown.Item>
                  </Col>
                  <Col xs={6} md={4} size="sm" className="nav-category" vertical>
                    <NavDropdown.Item className="py-0" href={`/catalog/detailbrands`}>
                      <span className="ml-3"><CgNametag />&nbsp;Бренды</span>
                    </NavDropdown.Item>
                  </Col>
              </NavDropdown>*/}
                        <Nav.Link href="/service"><GiAutoRepair/>&nbsp;Сервис</Nav.Link>
                    </Nav>
                    <Nav>
                        <a className="text-primary" onClick={() => {handleNavMsgAction('Звонок по кнопке вверху сайта\n' + new Date());window.location.href="#";}} target="_blank" href="tel:+77015471529"><VscCallOutgoing />&nbsp;+7&nbsp;701&nbsp;547-1529</a>
                    </Nav>
                    <Nav>
                        <NavDropdown variant="warning" alignRight="true" title={<IconContext.Provider value={{ title: "", className: "global-class-name" }}><BiSupport />&nbsp;Контакты</IconContext.Provider>} id="collasible-nav-dropdown">
                            <NavDropdown.Item onClick={() => {handleNavMsgAction('Звонок по кнопке вверху сайта (внутри контактов)\n' + new Date());window.location.href="#";}} target="_blank" href="tel:+7 701 547-1529"><VscCallOutgoing />&nbsp;Позвонить</NavDropdown.Item>
                            <NavDropdown.Item onClick={() => {handleNavMsgAction('Написать в whatsapp по кнопке вверху сайта (внутри контактов)\n' + new Date());window.location.href="#";}} target="_blank" href="https://wa.me/77015471529"><FaWhatsappSquare />&nbsp;Написать WhatsApp</NavDropdown.Item>
                            <NavDropdown.Item onClick={() => {handleNavMsgAction('Написать на почту по кнопке вверху сайта (внутри контактов)\n' + new Date());window.location.href="#";}} target="_blank" href="mail:info@sinomost.kz"><BiMailSend />&nbsp;Написать&nbsp;на&nbsp;почту</NavDropdown.Item>
                            <NavDropdown.Item onClick={() => {handleNavMsgAction('Смотреть на карте по кнопке вверху сайта (внутри контактов)\n' + new Date());window.location.href="#";}} target="_blank" href="https://yandex.kz/maps/-/CHa15R3s"><BiMap />&nbsp;Показать&nbsp;на&nbsp;карте</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/contact"><BsInfoCircle />&nbsp;Страница&nbsp;конатктов</NavDropdown.Item>
                            {/*<NavDropdown.Item href="/blog"><BsQuestionCircle />&nbsp;Вопросы&nbsp;и&nbsp;ответы</NavDropdown.Item>*/}
                        </NavDropdown>
                        {isAuthenticated ? logged_in_nav : logged_out_nav }
                        {login_form}
                        {registration_form}
                        {/*<NavDropdown variant="warning" alignRight="true" title=<GiCargoCrate /> id="collasible-nav-dropdown">
                <NavDropdown.Item href="/blog">Корзина&nbsp;техники</NavDropdown.Item>
                <Row>
                  <Col xs={4}>
                    <Image className="https://dev.sinomost.kz/media/reviews/imageholder.jpg" width="100%" height="100%" />
                  </Col>
                  <Col xs={8}>
                    <h6 className="mb-0">Product&nbsp;name</h6>
                    <small>24'000'000&nbsp;KZT</small>
                  </Col>
                </Row>
              </NavDropdown>*/}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    };
};

Navigation.propTypes = {
    logged_in: PropTypes.bool.isRequired,
    display_form: PropTypes.func.isRequired,
    handle_login: PropTypes.func.isRequired,
    handle_logout: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    carcats: state.cars.carcats,
    cars: state.cars.cars,
    tehcats: state.teh.tehcats,
    showLoginForm: state.core.showLoginForm,
    showRegisterForm: state.core.showRegisterForm,
    auth: state.auth
});

export default connect(mapStateToProps, { showModalForm, hideModalForm, fetchCarCats, fetchAllCars, fetchTehCats, logout })(Navigation);
